import React, {useState, useEffect, useRef} from 'react';
import {withRouter} from "react-router-dom";
import {Row, Col, Input, Button} from 'antd';
import {useSelector} from "react-redux";
import Chat from './Chat';
// import MapImage from "../../../assets/images/newmap1.png";
import MapImage from "../../../assets/images/coin.png";
import Buttons from './Buttons';
import axios from 'axios';
import { USER_SERVER } from '../../../config';
import { removeCookie } from '../../../cookie/cookie';
import Swal from 'sweetalert2';


function LandingPage(props) {
    const chatRef = useRef(null);

    // let user = useSelector((state) => state.user);
    // const UserInfo = user.userData;     // UserInfo={token, user_id}
    // const isAuth = UserInfo?.isAuth;

    const [RecStatus, setRecStatus] = useState('ready');
    const [WaitAnswer, setWaitAnswer] = useState(false);
    const imageRef = useRef();
    const [ImgUrl, setImgUrl] = useState("");
    const [ImgUrlToSend, setImgUrlToSend] = useState("");
    const [Img, setImg] = useState();

    const [chat_height, setChatHeight] = useState(window.innerHeight - 150);

    // const user_id = 'ghlee1'
    const user_id = (() => {
        // localStorage에서 user_id를 확인
        const savedUserId = localStorage.getItem('aicubeint_user_id');
        if (savedUserId) {
            return savedUserId;
        }
        
        // 없으면 12자리 랜덤 숫자 생성
        const randomUserId = 'u' + Math.floor(Math.random() * 1000000000000).toString().padStart(12, '0');
        localStorage.setItem('aicubeint_user_id', randomUserId);
        return randomUserId;
    })();


    const token = '1234567890'
    const isAuth = true
    const UserInfo = {
        user_id: user_id,
        token: token,
        isAuth: isAuth
    }

    window.addEventListener('resize', () => {
        console.log("Updated viewport height:", window.innerHeight);
        setChatHeight(window.innerHeight - 150);
    });

    useEffect(() => {
        console.log('ImgUrl=', ImgUrl);
    }, [ImgUrl]);

    function loginHandler(){
        window.location.href = "/login";
    }

    const handleButtonSend = async () => {
        if (!isAuth) {
            loginHandler();
            return;
        }
        if (chatRef.current) {
            await chatRef.current.onClickSend();
            setImg(null);
        }
    }

    const handleRecStart = async () => {
        if (!isAuth) {
            loginHandler();
            return;
        }
        if (chatRef.current) {
            await chatRef.current.onClickRecStart();
        }
    }

    const handleRecStop = async () => {
        if (!isAuth) {
            loginHandler();
            return;
        }
        if (chatRef.current) {
            await chatRef.current.onClickRecStop();
        }
    }

    const handleReset = async () => {
        if (!isAuth) {
            loginHandler();
            return;
        }
        if (imageRef.current) {
            setImgUrl("");
            setImgUrlToSend("");
            setImg(null);
            URL.revokeObjectURL(ImgUrl);
            URL.revokeObjectURL(ImgUrlToSend);
        }
        if (chatRef.current) {
            await chatRef.current.onClickReset();
        }
    }

    const handleCustom1 = async () => {
        if (!isAuth) {
            loginHandler();
            return;
        }
        if (chatRef.current) {
            await chatRef.current.onClickCustom1();
        }
    }

    const handleCustom2 = async () => {
        if (!isAuth) {
            loginHandler();
            return;
        }
        if (chatRef.current) {
            await chatRef.current.onClickCustom2();
        }
    }

    const handleUploadImage = async () => {
        if (!isAuth) {
            loginHandler();
            return;
        }
        console.log("handleUploadImage");
        if (imageRef.current) {
            console.log("imageRef.current.click()");
            imageRef.current.click()
        }
    }

    const style_container = {
        borderRadius: '10px',
        // overflow: 'hidden',
        boxShadow: '0 0 10px rgba(0, 255, 255, 0.3)',
        // width: '90%',           // 전체 화면의 90% 너비
        width: '90%',              // 전체 화면의 90% 너비
        margin: '0 auto'       // 좌우 중앙 정렬
    }

    //////////////////////////////////////////////////////////////////////////
    async function logoutHandler(){
        const response = await axios.get(`${USER_SERVER}/web/logoutgoogle`);
        if (response.status === 200) {
            removeCookie('w_auth');
            //history.push("/login");
            console.log('logout successfully');
            window.location.reload(); // 페이지 새로고침
        } else {
            Swal.fire({ icon: "error", title: ("Oops..."), text: ("Something went wrong, Logout Failed") });
        }
    };

    async function loginHandler(){
        window.location.href = "/login";
    };


    // const login_button = isAuth ? 
    // <Button onClick={logoutHandler} style={{fontWeight: 'bold', fontSize: '16px', backgroundColor: '#D3D3D3', marginRight: '10px'}}>Logout</Button> : 
    // <Button onClick={loginHandler} style={{fontWeight: 'bold', fontSize: '16px', backgroundColor: '#D3D3D3', marginRight: '10px'}}>Login</Button>;
    //////////////////////////////////////////////////////////////////////////

    return (
        <div>
            {/* nav bar */}
            <Row justify="center" align="middle" style={{height: '100px'}}>
                <Col span={20} style={{ color: 'white', textAlign: 'center' }}>
                    <Row style={{alignItems: 'center', justifyContent: 'center' }}>
                        <span style={{ fontSize: '24px', fontWeight: 'bold' }}>
                            Cube AI Agent
                        </span>
                    </Row>
                    <Row style={{alignItems: 'center', justifyContent: 'center' }}>
                        <span style={{ fontSize: '16px', textAlign: 'center', color: '#C3C3C3' }}>
                            Your Ai Agent for Cube Protocol 
                        </span>
                    </Row>
                </Col>
                {/* <Col span={4}>
                    <Row justify="end" style={{marginTop: '10px'}}>
                        {login_button}
                    </Row>
                </Col> */}
            </Row>

            <Row>
                <Col span={22} offset={1}>
                    <Row align='middle' justify='center' style={style_container}>
                        <Col style={{backgroundColor: '#141c21', color: 'white', height: `${chat_height}px`, width: '100px'}}>
                            <Buttons
                                onClickSend={handleButtonSend}
                                onClickUploadImage={handleUploadImage}
                                onClickRecStart={handleRecStart}
                                onClickRecStop={handleRecStop}
                                onClickReset={handleReset}
                                onClickCustom1={handleCustom1}
                                onClickCustom2={handleCustom2}
                                RecStatus={RecStatus}
                                WaitAnswer={WaitAnswer}
                            />
                        </Col>
                        <Col style={{backgroundColor: 'rgb(33,33,33)', color: 'white', height: `${chat_height}px`, width: 'calc(100% - 100px)'}}>
                            <Chat
                                ref={chatRef}
                                UserInfo={UserInfo}
                                RecStatus={RecStatus}
                                setRecStatus={setRecStatus}
                                WaitAnswer={WaitAnswer}
                                setWaitAnswer={setWaitAnswer}
                                Img={Img}
                                chat_height={chat_height}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
            
        </div>
    )
}

export default withRouter(LandingPage)
